// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"5809cd0d","488":"a83ca662"}[chunkId] + ".chunk.js";
};